// Modules
import axios, { AxiosRequestConfig } from "axios"

// RBAC
import rbacHttpInterceptor from "~rbac/utils/rbacHttpInterceptor"

// Interceptors
import {
  logoutInterceptor,
  httpErrorInterceptor,
  httpSuccessInterceptor,
  httpRefreshTokenInterceptor,
  httpTokenInjectorInterceptor,
} from "~utils/httpInterceptors"

// Define default options
const defaultOptions: AxiosRequestConfig = {
  headers: {
    common: {
      Accept: "application/json",
      "Accept-Language": "en-US",
    },
  },
}

// Create axios instance
const instance = axios.create(defaultOptions)

// Use interceptor to inject the token to the request
instance.interceptors.request.use(httpTokenInjectorInterceptor)

// Use interceptor to map API paths using RBAC
instance.interceptors.request.use(rbacHttpInterceptor)

// Use interceptor to handle the refresh token if we get a 401 error
instance.interceptors.response.use(httpSuccessInterceptor, error =>
  httpRefreshTokenInterceptor(error, instance)
)

// Use interceptor to handle the api errors
instance.interceptors.response.use(httpSuccessInterceptor, httpErrorInterceptor)

// Use interceptor to handle the logout after a second 401 error and no more retries
instance.interceptors.response.use(httpSuccessInterceptor, logoutInterceptor)

export const Api = instance
